/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Custom_FontsInputs */



/**
* | output |
* | --- |
* | "Custom Fonts" |
*
* @param {Custom_FontsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const custom_fonts = /** @type {((inputs?: Custom_FontsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Custom_FontsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Polices personnalisées")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzerdefinierte Schriftarten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caratteri personalizzati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пользовательские шрифты")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fuentes personalizadas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自定义字体")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カスタムフォント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कस्टम फोंट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fontes personalizadas")
	return /** @type {LocalizedString} */ ("Custom Fonts")
});